import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import SitePage from '../components/SitePage';

class SiteOfDelegate extends Component {
  constructor(props) {
    super(props)
    this.delegateId = this.props.match.params.delegateId
  }

  render() {
    const pageProps = {
      fetchDictionary: (dictType, callback) => {
        DataFetcher.distionary(dictType, {
          success: callback
        })
      },
      fetchDistrict: (params, callback) => {
        DataFetcher.districtTree({
          success: callback
        })
      },
      fetchSites: (params, callback) => {
        DataFetcher.delegateSitePage(
          {
            ...params,
            delegateId: this.delegateId,
          }, 
          {
            success: callback
          }
        )
      },
      createSite: (params, callback, completed) => {
      },
      updateSite: (params, callback, completed) => {
        DataFetcher.delegateUpdateSite(
          {
            ...params,
            delegateId: this.delegateId,
          }, 
          {
            success: callback,
            completed
          }
        )
      },
      shutdownTime: (params, callback, completed) => {
        DataFetcher.delegateUpdateShutdownTime(
          {
            ...params,
            delegateId: this.delegateId,
          }, 
          {
            success: callback,
            completed
          }
        )
      },
      delegateProfile: (params, callback) => {
        DataFetcher.delegateProfile(
          {
            ...params,
            id: this.delegateId
          }, 
          {
            success: callback
          }
        )
      }
    }

    return <SitePage {...pageProps}/>
  }
}

export default SiteOfDelegate;


// WEBPACK FOOTER //
// ./src/modules/SiteOfDelegate.js